
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/8dabc29d-8188-4a81-908f-bf6a8dda8fde.png" 
                alt="Aviator Casino Logo" 
                className="h-10 w-auto"
              />
              <span className="text-xl font-bold">Aviator Casino</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Experience the thrill of Aviator crash game with provably fair technology. Play responsibly and enjoy the best online casino experience in India.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/games" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Games
                </Link>
              </li>
              <li>
                <Link to="/how-to-play" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  How to Play
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Game Info</h3>
            <ul className="space-y-2">
              <li className="text-slate-400 text-sm">
                <strong className="text-white">RTP:</strong> 97%
              </li>
              <li className="text-slate-400 text-sm">
                <strong className="text-white">Max Win:</strong> 10,000x
              </li>
              <li className="text-slate-400 text-sm">
                <strong className="text-white">Provider:</strong> Spribe
              </li>
              <li className="text-slate-400 text-sm">
                <strong className="text-white">Type:</strong> Crash Game
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Responsible Gaming</h3>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Play responsibly. Gambling should be entertaining. Never bet more than you can afford to lose.
            </p>
            <div className="flex items-center gap-2 text-sm text-slate-400">
              <span className="text-2xl">18+</span>
              <span>Players must be 18 years or older</span>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm text-center md:text-left">
              © 2026 Aviator Casino. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs text-center md:text-right">
              Aviator is a registered trademark of Spribe. This is an informational website.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
